// extracted by mini-css-extract-plugin
module.exports = {"tooltip--content":"Tooltip_tooltip--content__1Y7Gz","tooltip--icon":"Tooltip_tooltip--icon__1vBRX"};